import Vue from 'vue'
import format from 'date-fns/format'
import distanceInWordsToNow from 'date-fns/distance_in_words_to_now'
import distanceInWordsStrict from 'date-fns/distance_in_words_strict'
import {format as d3Format} from 'd3-format'
import {Roles} from '@/lib/definitions'
import {startCase} from 'lodash'

Vue.filter('dateFromNow', (value, postfix) => {
  return value ? distanceInWordsToNow(value) : postfix
})

Vue.filter('daysFromNowStrict', (value, now, postfix) => {
  const d = value ? distanceInWordsStrict(value, new Date()) : postfix
  return d.split(' ')[0] + d.split(' ')[1].slice(0, 1) // 2 days => 2d
})

Vue.filter('formattedDate', date => format(date, 'DD MMM YYYY - HH:mm'))

Vue.filter('formattedDateNoHour', date => format(date, 'DD/MM/YYYY'))

Vue.filter('formattedHour', date => format(date, 'HH:mm:ss'))

Vue.filter('pluralize', function(value, string, plural) {
  plural = plural || string + 's'
  if (value === 0) {
    return 'No ' + plural
  } else if (value === 1) {
    return value + ' ' + string
  } else {
    return value + ' ' + plural
  }
})

Vue.filter('pluralizeWord', function(word, value) {
  return value === 1 ? word : word + 's'
})

Vue.filter('percentage', function(value, dec = 0) {
  if (value === 0) return '0%'
  else if (value === 1) return '100%'
  else return d3Format(`.${dec}%`)(value)
})

Vue.filter('roleArticle', function(role) {
  const r = role.toUpperCase()
  if (r === Roles.MANAGER || r === Roles.MEMBER) {
    return 'a ' + startCase(role)
  } else if (r === Roles.ADMIN || r === Roles.OWNER) {
    return 'an ' + startCase(role)
  } else {
    console.error('roleArticle:::Unknown role')
  }
})
